var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddressBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "48px",
    viewBox: "0 0 42 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Parth",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "address-book",
    fill: "#E2E8F6",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.875,15 C41.49375,15 42,14.49375 42,13.875 L42,10.125 C42,9.50625 41.49375,9 40.875,9 L39,9 L39,4.5 C39,2.015625 36.984375,0 34.5,0 L4.5,0 C2.015625,0 0,2.015625 0,4.5 L0,43.5 C0,45.984375 2.015625,48 4.5,48 L34.5,48 C36.984375,48 39,45.984375 39,43.5 L39,39 L40.875,39 C41.49375,39 42,38.49375 42,37.875 L42,34.125 C42,33.50625 41.49375,33 40.875,33 L39,33 L39,27 L40.875,27 C41.49375,27 42,26.49375 42,25.875 L42,22.125 C42,21.50625 41.49375,21 40.875,21 L39,21 L39,15 L40.875,15 Z M19.5,12 C22.809375,12 25.5,14.690625 25.5,18 C25.5,21.309375 22.809375,24 19.5,24 C16.190625,24 13.5,21.309375 13.5,18 C13.5,14.690625 16.190625,12 19.5,12 Z M30,34.2 C30,35.19375 29.0625,36 27.9,36 L11.1,36 C9.9375,36 9,35.19375 9,34.2 L9,32.4 C9,29.41875 11.821875,27 15.3,27 L15.76875,27 C16.921875,27.478125 18.178125,27.75 19.5,27.75 C20.821875,27.75 22.0875,27.478125 23.23125,27 L23.7,27 C27.178125,27 30,29.41875 30,32.4 L30,34.2 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressBook);
export default __webpack_public_path__ + "static/media/address-book.58e2e2ec1fafb30f22e46b21d4422c51.svg";
export { ForwardRef as ReactComponent };